import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUpcFromCatalogBib } from 'app/helpers/bib/bibHelpers';
import useSyndeticsUnbound, { SUPPORTED_ENRICHMENT_IDS } from 'app/hooks/useSyndeticsUnbound';
import { selectBibEntities, selectCatalogBibEntities } from 'app/selectors/EntitiesSelector';
import ReadingLevel from './ReadingLevel';

const ReadingLevelContainer = ({ metadataId }) => {
  const bibs = useSelector(selectBibEntities);
  const catalogBibs = useSelector(selectCatalogBibEntities);
  const [hasContent, setHasContent] = useState(false);

  const isbn = bibs.getIn([metadataId, 'briefInfo', 'isbns', 0]);
  const upc = getUpcFromCatalogBib(catalogBibs.get(metadataId));

  const onSyndeticsUnboundLoaded = useCallback(
    connectorApi => {
      const { isEnrichmentShown, populate } = connectorApi;

      populate({ isbn, upc });

      setTimeout(() => {
        setHasContent(isEnrichmentShown(SUPPORTED_ENRICHMENT_IDS.READING_LEVEL));
      }, 500);
    },
    [isbn, setHasContent, upc]
  );

  useSyndeticsUnbound(onSyndeticsUnboundLoaded);

  return <ReadingLevel isVisible={hasContent} />;
};

ReadingLevelContainer.propTypes = {
  metadataId: PropTypes.string.isRequired
};

export default ReadingLevelContainer;
